import { Injectable } from '@angular/core';
import { BaseService, Pagination } from '../core';
import { Ledger } from '../dto/ledger';

@Injectable({
  providedIn: 'root',
})
export class LedgerService extends BaseService {
  getPointLedger(pagination: Pagination) {
    return super.paginate<Ledger>('/ledger/point', pagination);
  }

  getMembershipPointLedger(pagination: Pagination) {
    return super.paginate<Ledger>('/ledger/point/membership', pagination);
  }

  getCreditLedger(pagination: Pagination) {
    return super.paginate<Ledger>('/ledger/credit', pagination);
  }
}
